// @ts-check

/**
 * Mapbox map constants and configuration.
 * Defines breakpoints, padding, and zoom settings aligned with Bootstrap 5.
 */

/**
 * Bootstrap 5 breakpoints for responsive map behavior.
 * @see https://getbootstrap.com/docs/5.1/layout/breakpoints/
 */
export const BREAKPOINTS = {
  xs: 0, // Extra small devices (portrait phones, <576px)
  sm: 576, // Small devices (landscape phones, ≥576px)
  md: 768, // Medium devices (tablets, ≥768px)
  lg: 992, // Large devices (desktops, ≥992px)
  xl: 1200, // Extra large devices (large desktops, ≥1200px)
  xxl: 1400 // Extra extra large devices (larger desktops, ≥1400px)
};

/**
 * Map padding per Bootstrap breakpoint.
 * Ensures map content is visible with appropriate margins for UI panels.
 */
export const MAP_PADDING = {
  xs: { top: 20, bottom: 20, left: 20, right: 20 },
  sm: { top: 30, bottom: 30, left: 30, right: 30 },
  md: { top: 40, bottom: 40, left: 40, right: 40 },
  lg: { top: 50, bottom: 50, left: 100, right: 100 },
  xl: { top: 50, bottom: 50, left: 100, right: 100 },
  xxl: { top: 50, bottom: 50, left: 100, right: 100 }
};

/**
 * Default zoom settings for different map operations.
 */
export const ZOOM_SETTINGS = {
  islandZoom: 8, // Zoom level when focusing on individual islands
  duration: 1000, // Animation duration in milliseconds
  curve: 1.42, // Animation curve for flyTo (Mapbox default)
  speed: 1.2 // Animation speed multiplier
};

/**
 * Get appropriate padding based on current window width.
 * @returns {{top: number, bottom: number, left: number, right: number}} Padding object
 */
export function getCurrentPadding() {
  const width = window.innerWidth;

  if (width >= BREAKPOINTS.xxl) {
    return MAP_PADDING.xxl;
  } else if (width >= BREAKPOINTS.xl) {
    return MAP_PADDING.xl;
  } else if (width >= BREAKPOINTS.lg) {
    return MAP_PADDING.lg;
  } else if (width >= BREAKPOINTS.md) {
    return MAP_PADDING.md;
  } else if (width >= BREAKPOINTS.sm) {
    return MAP_PADDING.sm;
  } else {
    return MAP_PADDING.xs;
  }
}

/**
 * Get current breakpoint name based on window width.
 * @returns {"xs" | "sm" | "md" | "lg" | "xl" | "xxl"} Current breakpoint
 */
export function getCurrentBreakpoint() {
  const width = window.innerWidth;

  if (width >= BREAKPOINTS.xxl) {
    return "xxl";
  } else if (width >= BREAKPOINTS.xl) {
    return "xl";
  } else if (width >= BREAKPOINTS.lg) {
    return "lg";
  } else if (width >= BREAKPOINTS.md) {
    return "md";
  } else if (width >= BREAKPOINTS.sm) {
    return "sm";
  } else {
    return "xs";
  }
}
